import { Article } from '@ca/core/models';

export const articlesFeatureKey = 'articles';

export interface ArticlesState {
    loading: boolean;
    articles?: Article[];
    error?: unknown;
    article?: Article;
    articleError?: unknown;
    updateArticleSuccess: boolean;
    deleteArticleSuccess: boolean;
}

export const initialArticlesState: ArticlesState = {
    loading: false,
    articles: [],
    error: undefined,
    article: undefined,
    articleError: undefined,
    updateArticleSuccess: false,
    deleteArticleSuccess: false,
};
